<template>
  <div>
    <v-card>
      <v-row class="pa-3" v-if="componenteEvento.agregar_submodulo">
        <v-spacer></v-spacer>
        <ButtonComp @click="addItem" textButton="Agregar fecha" iconBut="fas fa-plus" normalButton />
      </v-row>

      <ComundataTablecompVue whitSearch noResultsText="Sin datos para mostrar" :headers="FechasEntrevistasHeaders"
        :items="fechaEntrevistas" :search="search">

        <template v-slot:action_editar="{ item }">
          <ButtonComp v-if="componenteEvento.editar_submodulo" @click="editItem(item)" tooltipText="Editar fecha"
            editButton />
        </template>

        <template v-slot:action_ver="{ item }">
          <ButtonComp v-if="componenteEvento.visualizar_submodulo" @click="editItem(item, true)" verButton
            tooltipText="Ver fecha" />
        </template>

        <template v-slot:action_borrar="{ item }">
          <ButtonComp v-if="componenteEvento.borrar_submodulo" @click="deleteConfirm(item)" tooltipText="Eliminar fecha"
            deleteButton />
        </template>
      </ComundataTablecompVue>
    </v-card>
    <!--  FIN lIST DE REGISTROS --->

    <!-- modal para crear/editar documentos -->
    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp v-model="dialog" maxWidth="700" @close-modal="dialog = false" :title="formTitle">
        <template v-slot:body>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <textfieldComp textLabel="Descripción" type="text" v-model="editedItem.descripcion"
                :rules="validationRules.validateCampo" :readonly="bloquearCampo" />
            </v-col>

            <v-col cols="12" sm="6" md="6" xs="12">
              <textfieldComp textLabel="Información" type="text" v-model="editedItem.informacion"
                :rules="validationRules.validateCampo" :readonly="bloquearCampo" />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6" md="6" xs="12">
              <AutocompleteComp textLabel="Nivel" v-model="editedItem.id_nivel" :items="listCondiciones"
                item-text="nivel.desc_nivel" item-value="id" return-object @change="GetGrados" />
            </v-col>

            <v-col cols="12" sm="6" md="6" xs="12">
              <AutocompleteComp textLabel="Grado" v-model="editedItem.id_grado" :items="listGrados"
                item-text="grado.desc_grado" item-value="id" />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6" md="6" xs="12">
              <v-menu v-model="menu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="editedItem.desde" label="Desde" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="selectedDate" :allowed-dates="allowedDates" no-title scrollable
                  @input="onDateSelected"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="6" xs="12">
              <v-menu v-model="menu2" :close-on-content-click="true" :nudge-right="40" transition="scale-transition"
                offset-y  min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="editedItem.hasta" label="Hasta" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="selectedDate2" :allowed-dates="allowedDates" no-title scrollable
                  @input="onDateSelected2"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-center">
              <h4>Cantidad máxima de postulantes diarios:</h4>
            </v-col>
            <v-col cols="12">
              <v-row dense>
                <v-col cols="6" class="d-flex align-center justify-end">
                  <v-row dense>
                    <v-col cols="12" class="d-flex align-center justify-end">
                      <v-btn @click="increment" dark color="primary" x-small><v-icon dark> mdi-plus
                        </v-icon></v-btn>
                    </v-col>
                    <v-col cols="12" class="d-flex align-center justify-end">
                      <v-btn @click="decrement" color="error" dark x-small><v-icon dark> mdi-minus
                        </v-icon></v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6" class="d-flex align-center justify-start">
                  <v-text-field v-model="count"  outlined style="max-width: 60px " hide-details>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer />
          <ButtonComp v-if="evento == 'editar'" @click="editFecha(editedItem.id)" textButton="Guardar cambios"
            iconBut="fas fa-save" normalButton />
          <ButtonComp v-if="evento == 'agregar'" @click="addDate" iconBut="fas fa-save" textButton="Guardar"
            normalButton />
        </template>
      </ComunDialogComp>

    </v-form>
    <!--------->

    <!-- //////////////Modal para confirmar eliminacion /////////////////////    -->
    <ComunDialogComp v-model="dialog_confirm" Confirmdialog @close-modal="dialog_confirm = false"
      @confirm-item="funcionConfirm('si')" @cancel-item="funcionConfirm('no')" titleWindow="Confirmar">
      <template v-slot:body>
        {{ desc_confirm }} <br />
        {{ name_confirm }}
      </template>
    </ComunDialogComp>

    <ComunDialogComp v-model="dialog_delete" Deletedialog @close-modal="dialog_delete = false"
      @delete-item="funcionConfirm('si')" @cancel-item="funcionConfirm('no')" titleWindow="Eliminar fecha">
      <template v-slot:body>
        {{ desc_confirm }} <br />
        {{ name_confirm }}
      </template>
    </ComunDialogComp>
    
    <!-- fin de modal de borrar registro -->
  </div>
</template>

<script>
import moment from "moment";
import axios from "../../../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import ComundataTablecompVue from "@/components/ComponentsEst/ComundataTablecomp.vue";
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import textfieldComp from '../../../../components/ComponentsEst/textfieldComp.vue';
import { FechasEntrevistasHeaders } from '../../../../helpers/headersTable';
import { validationRules } from '../../../../helpers/validatorHelpers';

export default {
  name: "Configuracion",
  props: {
    parametros: {
      type: Object,
      default: Object,
    },
  },
  components: {  ComundataTablecompVue, ButtonComp, ComunDialogComp, AutocompleteComp, textfieldComp },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 141, id_modulo: 5 }, //sud_modulo y modulo

    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    bloquearCampo: false,
    search: "",
    newAcademico: "",
    FechasEntrevistasHeaders,

    validdocs: true,

    //validaciones de formulario
  

    menu: null,
    menu2: null,
    selectedDate: null,
    selectedDate2: null,
    selectedDateFormatted: null,
    selectedDateFormatted2: null,

    // modal agregar editar documento
    dialog: false,
    evento: "",
    editedItem: {},
    documentos: [],
    fechaEntrevistas: [],

    //niveles y grados.
    listCondiciones: [],
    listGrados: [],
    id_colegio: null,
    niveles: null,

    // modal confirmacion
    name_confirm: "",
    id_delete: null,
    dialog_confirm: false,
    dialog_delete : false,
    desc_confirm: "",
    eventoConfirm: "",
    //////////////////////////////////
    count: 0,
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    formTitle() {
      return this.evento === "agregar"
        ? "Agregar nueva fecha"
        : this.evento === "ver"
          ? "Ver fechas de entrevistas"
          : "Editar fechas de entrevistas";

    },
    validationRules() {
      return validationRules
    }
  },

  mounted() {
    this.getDocumentos();
    this.getCondicionesNivel();
    this.id_colegio = this.datoLogin.id_colegio;
  },

  created() {
    this.actualizarParamentro();
  },

  watch: {
    parametroComponente() {
      this.getCondicionesNivel()
    }
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    ////////  METODO QUE LIMPIA EL FORMULARIO Y VARIABLES /////////
    async limpiarForm() {
      this.count = 0;
      this.editedItem = {
        id: 0,
        id_colegio: this.datoLogin.id_colegio,
        id_admision: "",
        id_usuario: this.datoLogin.id,
      };
      this.datesObject = {
        date: [],
      };
      this.$refs.formDatos.resetValidation();
    },

    onArchivoChange(e) {
      if (e !== undefined) {
        this.editedItem.archivo = e;
      } else {
        this.editedItem.archivo = null;
      }
    },

    onDateSelected(date) {
      this.selectedDate = date;
      this.editedItem.desde = moment(date).format("DD-MM-YYYY");
    },

    onDateSelected2(date) {
      this.selectedDate2 = date;
      this.editedItem.hasta = moment(date).format("DD-MM-YYYY");
    },

    // metodo del contador para fecha maxima de postulantes diarios.

    increment() {
      this.count++;
    },
    decrement() {
      if (this.count > 0) {
        this.count--;
      }
    },
    // metodo para trabajar con las fechas: desabilitar sabado, domingo y que inicie desde la fecha actual.
    allowedDates(val) {
      const selectedDate = new Date(val);
      const today = new Date();

      // Deshabilitar sábados (día de la semana 6) y domingos (día de la semana 5)
      if (selectedDate.getDay() === 6) {
        return false;
      }

      // Permitir solo fechas futuras (después o igual al día actual)
      return selectedDate >= today;
    },

    ////METODO PARA TRABAJAR LOS NIVELES Y GRADOS.
    async getCondicionesNivel() {
      try {
        let response = await axios.get(
          `/admision/condicion/${this.datoLogin.id_colegio}?${this.datoLogin.id_admision}`
        );
        this.listCondiciones = response.data;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    async GetGrados(condicion) {
      console.log("condicion", condicion)
      this.parametros.id_nivel = condicion.id;
      this.parametros.id_grado = "";
      this.listGrados = condicion.grados;
    },

    //////// METODO PARA HABILITAR MODAL PARA AGREGAR UN ITEM NUEVO //
    addItem() {
      this.getDocumentos();
      this.evento = "agregar";
      this.limpiarForm();
      this.bloquearCampo = false;
      this.dialog = true;

    },

    async getDocumentos() {
      try {
        let response = await axios.get(`/admision/entrevista/${this.datoLogin.id_colegio}`);
        this.fechaEntrevistas = response.data;
            
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    // agregar una nueva fecha//

    async addDate() {
      if (this.$refs.formDatos.validate() == true) {
        this.editedItem.ano_academico = parseInt(
          this.parametros.admisiones[0].ano_academico
        );

        this.editedItem.max_postulantes = this.count 
        try {
          const response = await axios.post(
            "admision/entrevista",
            this.editedItem
          );

          if (response.data.messageT == "S") {
            this.getDocumentos();

            this.agregarOtraFecha();
          }
          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
        } catch (e) {
          console.error(e);
        }
      }
    },

    //---------------- Editar Documento ----------------
    async editFecha(id) {
      if (this.$refs.formDatos.validate()) {
        this.editedItem.cant_max_postulantes = this.count
        let params = this.editedItem;

        try {
          let response = await axios.put(`/admision/entrevista/${id}`, params);
   
          if (response.data.messageT == "S") {
            this.getDocumentos();
            this.dialog = false;
            this.limpiarForm();
          }
          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });

        } catch (e) {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        }
      }
    },

    agregarOtraFecha() {
      this.eventoConfirm = "agregarOtraFecha";
      this.dialog_confirm = true;

      this.desc_confirm = "¿Desea agregar otra Fecha?";
    },

    //------------FUNCION CONFIRMAR -------------
    async funcionConfirm(resp) {
      if (resp == "si" && this.eventoConfirm == "borrar") {
        this.deleteDocumento();
      } else if (resp == "no" && this.eventoConfirm == "borrar") {
        this.dialog_confirm = false;
        this.dialog_delete = false;
      } else if (resp == "si" && this.eventoConfirm == "agregarOtraFecha") {
        this.dialog_confirm = false;
        this.dialog_delete = false;
        this.limpiarForm();
        this.$refs.formDatos.resetValidation();
      } else {
        this.dialog_confirm = false;
        this.dialog_delete = false;
        this.dialog = false;
      }
    },

    //---------obtener datos pàra editar
    editItem(item, ver = false) {
    // this.limpiarForm();
  
     this.count = item.cant_max_postulantes;
      this.evento = ver == true ? "ver" : "editar";
      if (ver == true) {
        this.bloquearCampo = true;
      } else {
        this.bloquearCampo = false;
      }

      let descripcionGrado;

        this.listCondiciones.forEach(condicion => {
          condicion.grados.forEach(gradoObjeto => {
            const grado = gradoObjeto.grado; 
            if (String(grado.id) === String(item.id_grado_condicion)) {
              descripcionGrado = grado.desc_grado;
            }
          });
        });

        // Después de la búsqueda, si tienes una descripción, haz algo con ella
        if (descripcionGrado) {
          this.listGrados = descripcionGrado;
          item.id_grado = this.listGrados // Asigna la descripción encontrada al item
        } else {
          console.log('No se encontró una descripción correspondiente.'); // Manejo de caso en que no hay coincidencia
        }
        this.editedItem = Object.assign({}, item);
        // ... (otros códigos)
        this.dialog = true;
          
          
 
    },

    // *****  confirmar el eliminar **********
    deleteConfirm(item) {
      this.eventoConfirm = "borrar";
      this.id_delete = item.id;
      this.name_confirm = `Descripción: ${item.descripcion}`;
      this.desc_confirm = "¿Está seguro de eliminar este registro?";
      this.dialog_delete = true;
    },

    //------------ borrar documento -------------

    async deleteDocumento() {
      try {
        let response = await axios.delete(
          `/admision/entrevista/${this.id_delete}`
        );
        this.dialog_delete = false;

        if (response.data.messageT == "S") {
          this.getDocumentos();
        }

        this.setEnviarMens({
          tipo: response.data.messageT,
          mensaje: response.data.message,
          tiempo: null,
        });
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },
  },
};
</script>

